import { memo, MutableRefObject, useRef } from 'react';

import { clsx } from 'clsx';
import Image from 'next/image';

import menuIcon from '@shared/assets/icons/searchmenu.svg';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
import { CategoriesDesktop, closeCategoriesModal, openCategoriesModal } from '@widgets/CategoriesMenu';

import cls from './MenuBlock.module.scss';

export const MenuBlock = memo(() => {
  const buttonRef = useRef() as MutableRefObject<HTMLButtonElement>;
  const dispatch = useAppDispatch();
  const openModal = useAppSelector((state) => state.categoriesModal.open);
  const viewPort = useAppSelector(getViewPort);

  const toggleModal = () => {
    if (openModal) {
      dispatch(closeCategoriesModal());
    } else {
      dispatch(openCategoriesModal());
    }
  };

  return (
    <div
      data-testid={'menu-block'}
      className={cls.wrap}
    >
      <Button
        aria-label={'Открыть каталог'}
        ref={buttonRef}
        data-testid={'catalog-btn'}
        addonLeft={
          <div className={cls.icon}>
            <Image
              src={menuIcon}
              alt={'/'}
              width={24}
              height={24}
            />
          </div>
        }
        onClick={toggleModal}
        className={clsx(cls.button, { [cls.buttonOpen]: openModal })}
      >
        <span>Каталог</span>
      </Button>
      {viewPort === 'desktop' && <CategoriesDesktop buttonRef={buttonRef} />}
    </div>
  );
});
